import { useMutation } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function useUpdateConfigFiltrosCulturas() {
  return useMutation(URL.OCUPACOES.ATUALIZAR("id"), async (body: any) => {
    const response = await http.put(URL.OCUPACOES.ATUALIZAR(body.id), {
      exibir: body.exibir,
    });
    return response;
  });
}

export default useUpdateConfigFiltrosCulturas;
